/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import axios from 'axios';

import './DevDetails.scss';

function DevDetails({ match }) {
  const [userData, setUserData] = useState({});

  const fetchUserDetail = async id => {
    try {
      const data = await axios.get(`https://cors-anywhere.herokuapp.com/https://torre.bio/api/bios/${id}`);
      setUserData(data.data);
    } catch (error) {
      throw new Error(error);
    }
  };

  useEffect(() => {
    const dev = match.params.id;
    fetchUserDetail(dev);
  }, [match.params.id]);

  const {
    person, strengths, interests, languages, opportunities,
  } = userData;

  return (
    <>
      {
        userData.person
          ? (
            <div id="details" className="d-flex flex-column mb-5">
              <div className="bio_info row mx-0 px-4">
                <div className="col-12 col-md-3">
                  <img
                    src={userData.person.pictureThumbnail}
                    className="img-thumbnail rounded mx-auto d-block "
                    alt="mentor pic"
                    style={{ height: '200px' }}
                  />
                  <div className="pt-3">
                    <small className="text-white">Social Media Links: </small>
                    {' '}
                    <br />
                    {person.links.map(item => (
                      <a key={item.id} className="text-secondary text-capitalize" href={item.address}>
                        {item.name}
                        {' '}
                        {' '}
                      </a>
                    ))}
                  </div>
                </div>
                <div className="bio_data col-12 col-md-9">
                  <h3 className="text-uppercase text-white py-3">
                    ABOUT
                    {person.name}
                  </h3>
                  <p className="text-white text-justify">
                    {person.professionalHeadline}
                  </p>
                  <p className="text-white text-justify">
                    {person.summaryOfBio}
                  </p>
                  <p className="text-white text-justify">
                    Stays in
                    {' '}
                    {' '}
                    {person.location.name}
                  </p>

                  <div className="card mx-3">
                    <h3 className="text-uppercase py-3"> Skills & Strength</h3>
                    {strengths.map(skill => <p key={skill.id}>{skill.name}</p>)}
                  </div>
                  <div className="card mx-3 mt-4">
                    <h3 className="text-uppercase py-3"> Languages</h3>
                    {languages.map(lang => (
                      <p key={lang.code}>
                        {lang.language}
                        {' '}
                        -
                        {' '}
                        {lang.fluency}
                      </p>
                    ))}
                  </div>
                  <div className="card mx-3 mt-4">
                    <h3 className="text-uppercase py-3"> Interests</h3>
                    {interests.map(likes => <p key={likes.code}>{likes.name}</p>)}
                  </div>
                  <div className="card mx-3 mt-4">
                    <h3 className="text-uppercase py-3"> Opportunities</h3>
                    {opportunities.map(opp => <p key={opp.id}>{opp.interest}</p>)}
                  </div>

                </div>
              </div>
            </div>
          )
          : <div className="loader">Loading...</div>
      }
    </>
  );
}

export default DevDetails;
